@import 'igws-breadcrumbs.less';

igws-breadcrumbs {
  .breadcrumbs,
  .breadcrumbs__children {

    li {
      &::before {
        margin: 0 15px 0 6px;
        transform: rotate(180deg);
      }
    }
  }

  .breadcrumb__more {
    margin: 0 15px 0 10px;
  }

  .more__menu {
    left: 0;
  }
}
